
import { Component, Prop, Vue } from "vue-property-decorator";
import LogTable from "@/components/logs/LogTable.vue";

@Component({
  components: { LogTable },
})

export default class RelayLogs extends Vue {

  @Prop({ default: null })
  public relay: any;

  private logs: any = [];

  private loading: boolean = false;

  private getLogs(params?: any) {
    if (this.relay.id) {
      this.loading = true;
      this.$store.dispatch("logs/getLogs", {
        query: {
          currentPage: "relay",
          entityId: this.relay.id,
          entityType: "relay",
          ...params,
        },
      }).then((res) => {
        this.logs = res;
      }).finally(() => this.loading = false);
    }
  }

}
